import { Component, OnInit, ViewChild } from '@angular/core';
import { Page } from '../shared/page';
import { QuarantineService } from './quarantine.service';
import { MatIconRegistry, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Spinplay } from '../shared/spinplay';
import { QuarantineOperationButtonRendererComponent } from './quarantine-operation-cell.component';
import { IsrcPipe } from '../pipes/isrc.pipe';

@Component({
  selector: 'app-quarantine',
  templateUrl: './quarantine.component.html',
  styleUrls: ['./quarantine.component.css']
})
export class QuarantineComponent implements OnInit {

  page: Page = {
    title: 'Quarantine',
    subtitle: ' - find songs with no acceptable matches to digital catalog'
  };

  public gridError = false;
  public itemsPerPage = 10;
  public columnDefs;
  public getRowHeight;
  public frameworkComponents = {
    operationButtonRenderer: QuarantineOperationButtonRendererComponent
  };

  private gridApi;

  constructor(private quarantineService: QuarantineService, private isrcPipe: IsrcPipe) { }

  ngOnInit() {
    this.columnDefs = [
      {
        headerName: '',
        field: 'value',
        cellRenderer: 'operationButtonRenderer',
        colId: 'params',
        width: 210,
        sortingOrder: [null],
        pinned: 'left',
        suppressSizeToFit: true,
        suppressResize: true,
        lockPosition: true
      },
      {
        headerName: 'Spins',
        field: 'spins',
        width: 65,
        lockPosition: true
      },
      {
        headerName: 'CCID',
        field: 'ccid',
        width: 75,
        lockPosition: true
      },
      {
        headerName: 'ISRC',
        field: 'isrc',
        width: 125,
        cellRenderer: (params) => {
          return this.isrcPipe.transform(params.value);
        },
        lockPosition: true
      },
      {
        headerName: 'Age',
        field: 'age',
        width: 80,
        lockPosition: true
      },
      {
        headerName: 'Artist',
        field: 'artist',
        width: 200,
        lockPosition: true
      },
      {
        headerName: 'Title',
        field: 'title',
        width: 200,
        lockPosition: true
      }
    ];

    this.getRowHeight = function (params) {
      return 55;
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.getQuarantined();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.gridApi.setQuickFilter(filterValue);

    this.gridOverlay(this.gridApi.getDisplayedRowCount());
  }

  getQuarantined() {
    this.gridError = false;
    this.gridApi.showLoadingOverlay();

    this.quarantineService.getQuarantined().subscribe(
      res => {
        this.gridApi.setRowData(res);
        this.gridOverlay(res.length);
        this.gridApi.paginationGoToPage(0);
        this.gridApi.sizeColumnsToFit();
      },
      error => {
        this.gridApi.setRowData([]);
        this.gridApi.hideOverlay();
        this.gridError = true;
      });
  }

  gridOverlay(rowCount: number) {
    if (rowCount === 0) {
      this.gridApi.showNoRowsOverlay();
    } else {
      this.gridApi.hideOverlay();
    }
  }

  approveSelected(spinPlay: Spinplay) {
    this.gridApi.showLoadingOverlay();
    this.quarantineService.approveQuarantine(spinPlay).subscribe(res => {
      if (res == null) {
        this.getQuarantined();
      }
    });
  }

  hideSelected(spinPlay: Spinplay) {
    this.gridApi.showLoadingOverlay();
    this.quarantineService.hideQuarantine(spinPlay.entityInstanceId).subscribe(res => {
      if (res == null) {
        this.getQuarantined();
      }
    });
  }

  changeItemsPerPage() {
    this.gridApi.paginationSetPageSize(this.itemsPerPage);
  }
}



// WEBPACK FOOTER //
// ./src/app/quarantine/quarantine.component.ts